<template>
    <div class="row">
        <div class="col-md-12">
          <b-form-fieldset>
            <b-input-group>
              <b-form-input type="text" v-model.trim="text" @keydown.native="filterByEnter" placeholder="Nombre"></b-form-input>
              <!-- Attach Left button -->
              <b-input-group-button slot="right">
                <b-button variant="primary"  @click="search">
                  <i class="fa fa-search"></i> Buscar
                </b-button>
              </b-input-group-button>
            </b-input-group>
          </b-form-fieldset>
        </div>
    </div>
</template>
<script>
const ENTER = 13
export default {
  name: 'Search',
  props: ['select'],
  data () {
    return {
      text: ''
    }
  },
  methods: {
    filterByEnter () {
      if (event.which === ENTER) {
        this.search()
      }
    },
    search () {
      this.$emit('search', this.text.trim().toLowerCase())
    }
  }
}
</script>
<style>
.btn-vertical-align {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Search.vue